import { useEffect, useState } from 'react';
import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { REACT_APP_APIM_URL } from '../../utilities/GlobalConstants';
import { useAuth } from 'react-oidc-context';
import { v4 as uuidv4 } from 'uuid';
import { convertDateTimeBasedOnConfigPostgre, getToken } from '../../utilities/helperFunctions';
import { IChangeHistoryLogArray, IChangeHistoryMinMaxTempLog, IChangeHistoryRuleLog } from '../../interfaces/IChangeHistoryLog';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

export const formatHistoryDetailText = (historyObject: IChangeHistoryMinMaxTempLog | IChangeHistoryRuleLog): JSX.Element => {
    if ("min_temp" in historyObject) {
        return (
            <span>
                Updated minimum temperature to <strong>{historyObject.min_temp}</strong>, maximum temperature to <strong>{historyObject.max_temp}</strong>
            </span>
        );
    } else {
        if (historyObject.severity === "" || historyObject.severity === null) {
            return (
                <span>
                    <strong>{historyObject.rule_name}</strong> for mode <strong>{historyObject.mode_name}</strong> was changed to <strong>{historyObject.mode_value}</strong>
                </span>
            );
        } else {
            return (
                <span>
                    Severity for <strong>{historyObject.rule_name}</strong> was changed to <strong>{historyObject.severity}</strong>
                </span>
            );
        }
    }
};
const HistoryTable = () => {
    const auth = useAuth();
    const [changeHistoryLog, setChangeHistoryLog] = useState<IChangeHistoryLogArray>([]);
    const [isLoading, setIsLoading] = useState(false);
    const columns: GridColDef[] = [
        {
            field: 'detail',
            headerName: 'Detail',
            width: 450,
            sortable: false,
            renderCell: (params) => formatHistoryDetailText(params.row)
        },
        {
            field: 'modified_by',
            headerName: 'Modified by',
            width: 150,
            sortable: false,
        },
        {
            field: 'modified_datetime',
            headerName: 'Modified datetime',
            width: 110,
            sortable: true,
            valueFormatter: (value) => convertDateTimeBasedOnConfigPostgre(value),
            flex: 1
        }
    ];
    const getChangeHistoryLog = async () => {
        setIsLoading(true);
        const accessToken = await getToken(auth);
        try {
            const response = await fetch(
                `${REACT_APP_APIM_URL}/thermalimage/getChangeHistoryLog`,
                {
                    method: "GET",
                    headers: {
                        Accept: "*/*",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                        "Access-Control-Allow-Origin": "*",
                    },
                }
            );
            const data = await response.json();
            if (data && data?.length) {
                setChangeHistoryLog(data);
            } else {
                setChangeHistoryLog([]);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setChangeHistoryLog([]);
            console.error('Error fetching change history log:', error);
        }
    };

    useEffect(() => {
        getChangeHistoryLog();
    }, []);
    
    return (
        <div>
            <Grid>
                <DataGrid
                    columns={columns}
                    rows={changeHistoryLog}
                    getRowId={(row) => uuidv4()}
                    disableColumnMenu={true}
                    disableRowSelectionOnClick={true} 
                    loading={isLoading}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 25
                            }
                        }
                    }}
                    pageSizeOptions={[]} //dont show row per page option
                    slotProps={{
                        loadingOverlay: {
                            variant: "linear-progress",
                            noRowsVariant: "skeleton"
                        }
                    }}
                    />
            </Grid>
        </div>
    );
};

export default HistoryTable;